import { useGlobalNavigationHotkeys } from "@permutation-city/ui";
import { Outlet, createRootRoute } from "@tanstack/react-router";

export const Route = createRootRoute({
  component: Root,
  notFoundComponent: () => {
    return (
      <p className="text-2xl font-bold text-center mt-24">404 NOT FOUND</p>
    );
  },
});

function Root() {
  useGlobalNavigationHotkeys();

  return (
    <div className="h-full">
      <Outlet />
    </div>
  );
}
